import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Menu, MenuItem } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import EditSite from '../../../components/Profile/AddSite/EditSite';
import { deleteSedeStore } from '../../../store/actions/UserAction';
import { showLoading, hideLoading } from "../../../store/actions/LoadingActions";
import Popup from '../../Modal/PopUp';
import './Location.scss';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

const menu = '/img/expand/menu-options.svg';

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    marginTop: 20,
    display: 'grid',
    '&::before': {
      height: 0
    }
  },

})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',
    flexFlow: 'column',
    alignItems: 'flex-start',
    padding: 0,
    cursor: 'auto',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#013957',
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: 24,
    display: 'block',
    border: '1px solid #e7e7e7',
    borderRadius: 4,
    '@media (max-width: 600px)': {
      padding: '24px 8px 24px',
    }
  },
})(MuiExpansionPanelDetails);

function Location(props) {

  const { elements, edit, id, arrSedeAll, uid, deleteSedeStore, showLoading, hideLoading } = props;

  const [expanded, setExpanded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  /* If there is error on production, try with this validation 
  let arrSedes = authClient && authClient.sede ? authClient.sede[0] : sede ? sede[0] : elements; */
  let arrSedes = elements;

  let item = id;

  let stateTitle = arrSedes.estado

  const handleChange = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);

  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    setExpanded(expanded ? false : true);
    setAnchorEl(null);
  }

  const handleDelete = () => {
    setOpen(true);
    setAnchorEl(null);
  };

  const changeStatus = isActive => {
    setExpanded(isActive ? true : false)
  }

  const handleClose = () => {
    setOpen(false);
  };

  const confirmDeleteSede = () => {
    handleClose();
    showLoading()
    // setLoadingFormData(true);

    deleteSedeStore(uid, id, arrSedeAll).then(res => {
    //   setLoadingFormData(false);
      hideLoading()

      setTimeout(() => {

        changeStatus();
        scroller.scrollTo('sitesForm', { smooth: true, offset: -64 });
      }, 2000)

    });
  };

  return (
    <>

      <Popup
        open={open}
        handleClose={handleClose}
        title={`¿Seguro que deseas eliminar la sede ${stateTitle}?`}
        subtitle='Si eliminas esta sede se borrará de tu lista, este cambio no puede recuperarse, para regresar presiona el botón Cancelar'
        primaryButton={true}
        primaryButtonVariant='primary'
        primaryButtonText='Sí, eliminar'
        primaryFunction={confirmDeleteSede}
        secondaryButton={true}
        secondaryButtonVariant='primarySolidOutlined'
      />

      {arrSedes && arrSedes ? (

        <ExpansionPanel expanded={expanded} >

          <ExpansionPanelSummary aria-controls="panel2a-content">

            <article className="cardMain">
              <header className="cardMain_header">
                <img
                  src="/img/profileClient/ubicaci-n.svg"
                  alt="icono ubicacion"
                  style={{ marginRight: 8, height: 24 }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                  <p className="cardMain_header_title">
                    {stateTitle}
                  </p>
                  {edit && <button className="menu-options-button-location" onClick={handleChange}>
                    <img src={menu} alt="Opciones" />
                  </button>}
                </div>
              </header>

              <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: 33, marginTop: 9 }}>
                <div style={{ marginRight: 45, marginBottom: 15, display: 'flex' }}>
                  <div style={{ marginRight: 45 }}>
                    <p style={{ fontWeight: 'bold' }}>Municipio</p>
                    <p className="cardMain_text">{arrSedes.municipio}</p>
                  </div>
                  {arrSedes && arrSedes.direccion && <div>
                    <p style={{ fontWeight: 'bold' }}>Dirección</p>
                    <p className="cardMain_text">{arrSedes.direccion}</p>
                  </div>}
                </div>
              </div>
            </article>

          </ExpansionPanelSummary>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
            <MenuItem onClick={handleEdit} >Editar sede</MenuItem>
            <MenuItem onClick={handleDelete}>Eliminar sede</MenuItem>
          </Menu>
          <ExpansionPanelDetails>

            {arrSedes ?
              <EditSite evento={changeStatus} id={item} sede={arrSedes} arrSedeAll={arrSedeAll} />
              : ('x')

            }
          </ExpansionPanelDetails>
        </ExpansionPanel>

      ) : (null)}
    </>


  );
}
const mapStateToProps = state => ({
  uid: state.authClient.uid,
  authClient: state.authClient
});

const mapDispatchToProps = dispatch => ({
  deleteSedeStore: (uid, item, allSedes) => dispatch(deleteSedeStore(uid, item, allSedes)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading())
});

export default connect(mapStateToProps, mapDispatchToProps) (Location);



